import React from "react";
import { GTMService } from "@di";
import { ReportGAEvents } from "@domains/trackers/gtmService";
import { ReportsGTMConstants } from "@domains/aggregates/Reports/ReportsGAConstants";
import { clearAllBodyScrollLocks } from "body-scroll-lock";
const TxnDetail = ({ viewCta, downloadCta, viewImg, downloadText, viewText, downloadImg, className, subtabName, stockName, }) => {
    const clickOnViewTxn = () => {
        viewCta();
        GTMService.gtmService(new ReportGAEvents(ReportsGTMConstants.ViewTxnDetails, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.PNL} | ${subtabName}`, `${stockName}`));
        clearAllBodyScrollLocks();
    };
    const clickOnDownloadTxn = () => {
        downloadCta();
        GTMService.gtmService(new ReportGAEvents(ReportsGTMConstants.DwnldTxnDetails, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.PNL} | ${subtabName}`, `${stockName}`));
        clearAllBodyScrollLocks();
    };
    return (React.createElement("div", { className: "txt-detail-container" },
        React.createElement("div", { className: `txn-detail ${className}` },
            clickOnViewTxn && viewText && (React.createElement("div", { className: "view-txn", onClick: clickOnViewTxn },
                viewImg && React.createElement("img", { src: viewImg, alt: "" }),
                " ",
                viewText)),
            clickOnDownloadTxn && downloadText && (React.createElement("div", { className: "download-txn", onClick: clickOnDownloadTxn },
                downloadImg && React.createElement("img", { src: downloadImg, alt: "" }),
                downloadText)))));
};
export default TxnDetail;
